import React from "react";

const money = value => value.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });

export default function PropertySnapshot({ address, value, year, valueLabel = "County appraised value", source, facts = [], nextStep }) {
  const hasValue = typeof value === "number" && Number.isFinite(value) && value > 0 && Number.isInteger(year);
  return <section className="border rounded p-4 mb-4" aria-label="Your property snapshot">
    <h2 className="h5">Your property snapshot</h2>
    {address && <p className="font-weight-bold">{address}</p>}
    {hasValue && <p><strong className="h3">{money(value)}</strong><br />{year} {valueLabel.toLowerCase()}</p>}
    {facts.length > 0 && <dl className="d-flex flex-wrap">{facts.map(({ label, value: fact }) => <div key={label} className="mr-4 mb-2">
      <dt className="small text-muted">{label}</dt><dd className="mb-0">{fact}</dd>
    </div>)}</dl>}
    {source && <p className="small text-muted">{source}</p>}
    <p className="mb-0">{nextStep}</p>
  </section>;
}
